import { render, staticRenderFns } from "./CompaniesConfirmation.vue?vue&type=template&id=2d8e05e7&scoped=true&"
import script from "./CompaniesConfirmation.vue?vue&type=script&lang=js&"
export * from "./CompaniesConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesConfirmation.vue?vue&type=style&index=0&id=2d8e05e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e05e7",
  null
  
)

export default component.exports